exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".user-panel .img-circle{\r\n  min-height: 45px;\r\n}", "", {"version":3,"sources":["Z:/adminlte-2-react/src/components/Sidebar/UserPanel.css"],"names":[],"mappings":"AAAA;EACE,iBAAgB;CAClB","file":"UserPanel.css","sourcesContent":[".user-panel .img-circle{\r\n  min-height: 45px;\r\n}"],"sourceRoot":""}]);

// exports
